
export class BuscarPorCodigoSistemaRequest {
    codigoSistema : string;
  
    constructor() {
      this.codigoSistema = "";
    
    }
  }
  